import axios from "./axios-decorator";

const baseAxiosUrl = window.location.origin;

/**
* Get meetings collection from the api.
*/
export const getMeetingsData = async (tipoCategoria?: string | null, channel?: string | null): Promise<any> => { 
    let filterTipoCategoria = tipoCategoria ? `?tipoCategoria=${tipoCategoria}` : ``;
    let filterChannel = channel ? `?channel=${channel}` : ``;

    let url = `${baseAxiosUrl}/meeting/getall${filterTipoCategoria}${filterChannel}`;  
    return await axios.getAnonymous(url, undefined, false);
}

/**
* Get specific meeting from the api.
*/
export const getMeetingData = async (ancora: any): Promise<any> => {
    let url = `${baseAxiosUrl}/meeting/getmeeting?ancora=${ancora}`;
    return await axios.getAnonymous(url, undefined, false);
}

/**
* Get meeting queue.
*/
export const getMeetingQueueData = async (ancora: string, queueId: string, schedule?: string): Promise<any> => {
    let scheduleParam = schedule ? `&schedule=${schedule}` : ``;
    let url = `${baseAxiosUrl}/meeting/getqueue?ancora=${ancora}&id=${queueId}${scheduleParam}`;
    return await axios.getAnonymous(url, undefined, false);
}

/**
* Update assunto queue.
*/
export const updateAssuntoQueue = async (ancora: string, id: string, assunto: string): Promise<any> => {
    let url = `${baseAxiosUrl}/meeting/updateassuntoqueue?ancora=${ancora}&id=${id}&assunto=${assunto}`;
    return await axios.putAnonymous(url, null);
}

/**
* Start call (atendimento).
*/
export const startCall = async (id: string, ancora: string): Promise<any> => {
    let url = `${baseAxiosUrl}/meeting/startcall?id=${id}&ancora=${ancora}`;
    return await axios.putAnonymous(url, null);
}

/**
* Inactivate queue.
*/
export const inactivateQueue = async (id: string, ancora: string): Promise<any> => {
    let url = `${baseAxiosUrl}/meeting/inactivatequeue?id=${id}&ancora=${ancora}`;
    return await axios.putAnonymous(url, null);
}

/**
* Cancel queue.
*/
export const cancelQueue = async (id: string): Promise<any> => {
    let url = `${baseAxiosUrl}/meeting/cancelqueue?id=${id}`;
    return await axios.putAnonymous(url, null);
}

/**
* Rating.
*/
export const rating = async (id: string, ancora: string, rate: any): Promise<any> => {
    let url = `${baseAxiosUrl}/meeting/rating?id=${id}&ancora=${ancora}`;
    return await axios.putAnonymous(url, rate);
}

/**
* Update queue with external user info.
*/
export const updateQueueExternalUser = async (id: string, userProfile: any): Promise<any> => {
    let url = `${baseAxiosUrl}/meeting/updatequeueexternaluser?queueId=${id}`;
    return await axios.putAnonymous(url, userProfile);
}

/**
* Get app configs (app settings / azure settings) from the api.
*/
export const getAppConfig = async (): Promise<any> => {
    let url = `${baseAxiosUrl}/meeting/getappconfig`;
    return await axios.getAnonymous(url, undefined, false);
}

/**
* Get app settings Teams Apps from the api.
*/
export const getAppSettings = async (): Promise<any> => {
    let url = `${baseAxiosUrl}/meeting/getappsettings`;
    return await axios.getAnonymous(url);
}

/**
* Get locale.
*/
export const getLanguageMeetings = async (): Promise<any> => {
    let url = `${baseAxiosUrl}/meeting/getlocale`;
    return await axios.getAnonymous(url);
}

/**
 * Get Gov.BR Auth Url
 */
export const getAuthUrl = async (): Promise<any> => {
    let url = `${baseAxiosUrl}/sso.gov.br/getauthurl`;
    return await axios.getAnonymous(url);
}

/**
 * Get Gov.BR User profile
 */
export const getUserProfile = async (token: string): Promise<any> => {
    let url = `${baseAxiosUrl}/sso.gov.br/getuserprofile?token=${token}`;
    return await axios.getAnonymous(url);
}

/**
 * Get or Create meeting queue
 */
export const getOrCreateMeetingQueueAuth = async (ancora: string, requestId: string, userProfile: any): Promise<any> => {
    let url = `${baseAxiosUrl}/meeting/createmeetingqueueauth?ancora=${ancora}&requestId=${requestId}`;
    return await axios.putAnonymous(url, userProfile);
}

/**
 * Get meeting queue auth
 */
export const getMeetingQueueByRequestId = async (requestId: string): Promise<any> => {
    let url = `${baseAxiosUrl}/meeting/getmeetingqueuebyrequestid?requestId=${requestId}`;
    return await axios.getAnonymous(url);
}